import React from "react";

import config from "shared/config";

import {
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
  HelpBlock,
} from "react-bootstrap";

// Lite components feature a similar API like FsInput,
// but unlike them, they are not connected to formState
//
// Instead of updating the formState, they will call the
// updateFn prop onChanges
//
// They can be given a validationState via
// the `validationState` prop
export default class FsLiteInput extends React.Component {
  getValueFromUpdate(event) {
    return event.target.value;
  }

  getBootstrapValidationState() {
    // FIXME: validationMode?
    return this.props.validationState == null
      ? null
      : this.props.validationState === false
      ? "error"
      : "success";
  }

  getControlId() {
    return `form_${this.props.attribute}`;
  }

  update(event) {
    if (!this.props.updateFn) {
      return;
    }

    this.props.updateFn(this.props.attribute, this.getValueFromUpdate(event));
  }

  renderInput() {
    throw new Error("abstract");
  }

  render() {
    return (
      <FormGroup
        controlId={this.getControlId()}
        validationState={this.getBootstrapValidationState()}
      >
        <Col
          componentClass={ControlLabel}
          sm={this.props.labelColumnCount || config.formLabelColumnCount}
        >
          {this.props.label}
        </Col>

        <Col
          sm={this.props.inputColumnCount || config.formInputColumnCount}
          className="pull-right"
        >
          {this.renderInput()}
          <FormControl.Feedback />
          <HelpBlock>{this.props.help}</HelpBlock>
        </Col>
      </FormGroup>
    );
  }
}
